<script>
import con from '@services/connection'
import { user, simulador } from '@constants/URL'
import Title from '@components/section-title'
import rules from '@constants/Rules'
import Vue from 'vue'
import store from '@state/store'
import EditarAtivo from '@modal/simulador-editar-ativo'
import { GlobalBus } from '@services/bus'
import { getNumber } from '@utils/Format'
import { MODAL } from '@constants/Text'
import {
  RECOMENDACAO_LABELS,
  RECOMENDACAO_TEXT_COLORS,
} from '@modules/consolidator/constants/recomendacao'

export default {
  components: {
    Title,
    EditarAtivo,
  },
  props: {
    bus: {
      type: Object,
      default: null,
      required: true,
    },
    openClass: {
      type: Boolean,
      default: false,
    },
    plTotal: {
      type: Number,
      default: 0.0,
    },
    onlyOne: {
      type: Boolean,
      default: false,
    },
    plSugerido: {
      type: Number,
      default: 0,
    },
    plNaoAlocado: {
      type: Number,
      default: null,
    },
    fixados: {
      type: Array,
      default: [],
    },
    ativosAtuais: {
      type: Array,
      default: () => null,
    },
    janelaTempo: {
      type: Number,
      default: 6,
    },
    classes: {
      type: Array,
      default: () => {
        return []
      },
    },
    qualificado: Boolean,
  },
  data() {
    return {
      getNumber,
      busModal: new Vue(),
      searchAsset: '',
      loading: false,
      loadingAssets: false,
      headersAtivos: [
        {
          text: 'Ativo',
          align: 'left',
          value: 'nome_ativo',
          width: 260,
        },
        {
          text: 'Classe',
          value: 'classe',
          width: 200,
        },
        {
          text: 'Subclasse',
          value: 'subclasse',
          width: 200,
        },
        {
          text: 'Na base',
          value: 'utilizar',
          width: 100,
        },
        {
          text: 'Setor',
          value: 'setor',
          width: 160,
        },
        {
          text: 'Recomendação',
          value: 'recomendacao',
          width: 130,
        },
        {
          text: 'Tags',
          value: 'tags',
          width: 180,
        },
        {
          text: 'Comentário',
          value: 'comentario',
          width: 120,
        },
      ],
      ativos: [],
      recomendacaoLabels: RECOMENDACAO_LABELS,
      recomendacaoTextColors: RECOMENDACAO_TEXT_COLORS,
      ativosSelecionados: [],
      modo_unico_ativos: '',
      showSubclass: false,
      hideAlerts: false,
    }
  },
  computed: {
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
  },
  created() {
    this.bus.$on(MODAL.SEARCH_ASSET_SHORT, this.open)
  },
  beforeDestroy() {
    this.bus.$off(MODAL.SEARCH_ASSET_SHORT, this.open)
  },
  methods: {
    async _loadAssets() {
      if (this.loadingAssets) {
        return
      }
      this.loadingAssets = true
      const r = await con.get(simulador.ativos_escritorio)
      if (r.status === 200) {
        this.ativos = r.value
      } else {
        this.ativos = []
      }
      this.loadingAssets = false
    },
    open(opts) {
      if (this.ativos.length < 10) {
        this._loadAssets()
      }
      this.searchAsset = ''
      this.ativosSelecionados = []

      if (opts) {
        this.modo_unico_ativos = opts.modo
        this.showSubclass = opts.showSubclass
        this.hideAlerts = opts.hideAlerts
      } else {
        this.modo_unico_ativos = ''
        this.showSubclass = false
        this.hideAlerts = false
      }

      this.busModal.$emit('dialog', true)
    },
    async enviar() {
      this.bus.$emit('select-assets', this.ativosSelecionados)
      this.busModal.$emit('dialog', false)
    },
    selectAsset(asset) {
      const existente = [...this.fixados, ...this.ativosSelecionados].find(
        (a) => {
          return asset.nome_ativo === a.nome_ativo
        }
      )
      if (existente) {
        this.$showSnack({
          text: 'Este ativo já esta fixado',
          button: true,
        })
      } else {
        // Removendo possíveis valores antigos para R$ e % do ativo, já que está
        // tentando inserir um novo.
        // Motivo: Tentar adicionar um ativo no Portfólio Modelo.
        asset.pl = 0
        asset.percentual = 0
        this.busModal.$emit(
          MODAL.SIMULATOR_EDIT_ASSET,
          { ...asset },
          {
            modo: this.modo_unico_ativos,
            openClass: this.openClass,
            showSubclass: this.showSubclass,
            hideAlerts: this.hideAlerts,
            callback: (a) => {
              this.ativosSelecionados.push(a)
              if (this.onlyOne) {
                this.enviar()
              }
            },
          }
        )
      }
    },
    openEdit(asset) {
      this.busModal.$emit(
        MODAL.SIMULATOR_EDIT_ASSET,
        { ...asset },
        {
          modo: this.modo_unico_ativos,
          openClass: this.openClass,
          showSubclass: this.showSubclass,
          hideAlerts: this.hideAlerts,
          callback: (a) => {
            const index = this.ativosSelecionados.findIndex((a) => {
              return a.nome_ativo === asset.nome_ativo
            })
            if (index >= 0) {
              this.$set(this.ativosSelecionados, index, a)
            } else {
              this.ativosSelecionados.push(a)
            }
            if (this.onlyOne) {
              this.enviar()
            }
          },
        }
      )
    },
    dontFind() {
      // this.selectAsset({
      //   nome_ativo: this.searchAsset,
      // })
    },
    openSearchLong() {
      this.busModal.$emit('dialog', false)
      this.bus.$emit(MODAL.SEARCH_ASSET_LONG, this.ativosSelecionados, {
        modo: this.modo_unico_ativos,
        showSubclass: this.showSubclass,
        hideAlerts: this.hideAlerts,
      })
    },
    /**
     * Remover um ativo da lista de ativos selecionados.
     */
    deselect(asset) {
      this.ativosSelecionados = this.ativosSelecionados.filter((a) => {
        return a.nome_ativo !== asset.nome_ativo
      })
    },
    getRecomendacaoLabel(recomendacao) {
      return this.recomendacaoLabels[recomendacao] || recomendacao
    },
    getRecomendacaoStatusColor(recomendacao) {
      return this.recomendacaoTextColors[recomendacao] || '#7C89B7'
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" max-width="1320px" persistent>
    <Title title="Selecione o ativo" />

    <div class="row">
      <div :class="ativosSelecionados.length ? 'col-8' : 'col-12'">
        <!-- <v-text-field label="Pesquisa" /> -->
        <form action="#" @submit.prevent>
          <div class="input-group align-items-center">
            <v-text-field
              v-model="searchAsset"
              class="input short-search"
              append-icon=" "
              background-color="#E4E0E6"
              item-value="id"
              item-text="name"
              label=""
              full-width
              placeholder="Pesquisar"
            >
            </v-text-field>
            <button
              class="btn btn-icon btn-icon-secondary align-self-center"
              :style="{
                'background-color': '#E4E0E6',
              }"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19.276"
                height="19.966"
                viewBox="0 0 19.276 19.966"
              >
                <path
                  class="fill"
                  d="M19.967 18.186l-4.752-4.942a8.058 8.058 0 1 0-6.17 2.879 7.975 7.975 0 0 0 4.618-1.459l4.788 4.98a1.051 1.051 0 1 0 1.516-1.458zM9.045 2.1a5.958 5.958 0 1 1-5.958 5.961A5.965 5.965 0 0 1 9.045 2.1z"
                  transform="translate(-.984)"
                />
              </svg>
            </button>
          </div>
        </form>
        <div>
          <v-data-table
            :headers="headersAtivos"
            :loading="loadingAssets"
            :items="ativos"
            :search="searchAsset"
            height="220"
            fixed-header
            class="table-pointer"
            @click:row="selectAsset"
          >
            <template v-slot:item.aberto="{ value }">
              <v-icon
                small
                :color="value ? 'success' : 'red'"
                style="margin-right: 18px"
              >
                {{ value ? 'mdi-lock-open-outline' : 'mdi-lock-outline' }}
              </v-icon>
            </template>
            <template v-slot:item.utilizar="{ value }">
              <div :class="{ 'text-success': value }">
                {{ value ? 'Sim' : 'Não' }}
              </div>
            </template>
            <template v-slot:item.nome_ativo="{ value }">
              <div class="asset-name-cell">{{ value || '-' }}</div>
            </template>
            <template v-slot:item.recomendacao="{ value }">
              <BaseStatus
                v-if="value"
                soft
                :content="getRecomendacaoLabel(value)"
                :color="getRecomendacaoStatusColor(value)"
              />
              <small v-else>-</small>
            </template>
            <template v-slot:item.setor="{ value }">
              <small>{{ value || '-' }}</small>
            </template>
            <template v-slot:item.tags="{ value }">
              <div
                v-if="Array.isArray(value) && value.length"
                class="d-flex align-center flex-wrap"
                style="gap: 4px"
              >
                <v-chip
                  v-for="(tag, idx) in value.slice(0, 2)"
                  :key="idx"
                  x-small
                  outlined
                >
                  {{ tag }}
                </v-chip>
                <v-chip v-if="value.length > 2" x-small outlined>
                  +{{ value.length - 2 }}
                </v-chip>
              </div>
              <small v-else>-</small>
            </template>
            <template v-slot:item.comentario="{ value }">
              <v-icon small :color="value ? 'primary' : 'grey'">
                {{ value ? 'mdi-comment-text' : 'mdi-comment-outline' }}
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </div>

      <div v-if="ativosSelecionados.length" class="col-4">
        <p class="subhead text-bold"> Ativos selecionados </p>
        <v-divider />
        <v-list>
          <v-list-item-group style="max-height: 300px; overflow-y: auto">
            <v-list-item v-for="a in ativosSelecionados" :key="a.id_ativo">
              <v-list-item-content @click="openEdit(a)">
                <v-list-item-title>
                  <div
                    class="d-flex justify-content-between"
                    style="max-width: 100%"
                  >
                    <span class="selected-asset-name">
                      {{ a.nome_ativo || '—' }}
                    </span>
                    <small v-if="a.percentual && getNumber(a.percentual)">
                      {{
                        a.percentual +
                        ((a.percentual ? a.percentual.toString() : '').includes(
                          '%'
                        )
                          ? ''
                          : '%')
                      }}
                    </small>
                    <small v-else> {{ a.pl }} </small>
                  </div>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <small> {{ a.classe }} </small>
                </v-list-item-subtitle>
                <hr />
              </v-list-item-content>
              <v-list-item-action class="ml-1">
                <v-btn small icon @click="deselect(a)">
                  <v-icon small> mdi-close </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </div>
    </div>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close"> Voltar </BaseButton>
      <BaseButton dark @click="openSearchLong"> Ver lista completa </BaseButton>
      <BaseButton dark :loading="loading" hidden @click="dontFind">
        <strong> + </strong> Ativo não encontrado
      </BaseButton>
      <BaseButton primary :loading="loading" @click="enviar">
        Inserir
      </BaseButton>
      <v-spacer />
    </template>

    <EditarAtivo
      :bus="busModal"
      :pl-total="plTotal"
      :pl-sugerido="plSugerido"
      :pl-nao-alocado="plNaoAlocado"
      :ativos-atuais="ativosAtuais"
      :janelaTempo="janelaTempo"
      :qualificado="qualificado"
      :classes="classes"
      :ativosSelecionados="ativosSelecionados"
    />
  </BaseModal>
</template>

<style lang="sass" scope>
.table-pointer
  tbody tr:hover
    cursor: pointer
    background-color: var(--gray-1) !important

.asset-name-cell
  min-width: 240px
  font-size: 13px
  line-height: 18px
  white-space: normal
  word-break: break-word

.selected-asset-name
  min-width: 180px
  font-size: 13px
  line-height: 18px
  white-space: normal
  word-break: break-word
</style>
